import React, { useEffect, useState, useCallback } from "react";
import { useAuth0 } from "../../../react-auth0-spa";
import { Form, Modal, Spin } from "antd";
import config from "../../../api_config.json";
import { useAppContext } from "../../../context";
import axios from "axios";
import { SelectOrg } from "../../SelectOrg";
import { CREATE_CLIENTE } from "../../../graphql/queries/cliente";

const queryAllOrgs = `
  query GetAllOrgs {
    organizzaziones(first: 10000, order: createdAt_DESC) {
      edges {
        node {
          objectId
          nome
        }
      }
    }
  }`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const title = "Aggiungi Cliente";

const AggiungiClienteModal = (props) => {
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const [loading, setLoading] = useState(true);
  const env = isProd ? "prod" : "dev";
  const [form] = Form.useForm();
  const [allOrgs, setAllOrgs] = useState([]);

  const graphqlUrl = `${config.baseUrl[env]}/graphql`;

  const fetchAllOrgs = useCallback(async () => {
    try {
      const token = await getTokenSilently();
      const response = await axios({
        method: "post",
        url: graphqlUrl,
        data: {
          query: queryAllOrgs,
          variables: {},
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }, [getTokenSilently, graphqlUrl]);

  useEffect(() => {
    setLoading(true);
    fetchAllOrgs()
      .then((response) => {
        setAllOrgs(response);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [fetchAllOrgs, props.orgId]);

  const orgsToExclude = [
    props.orgId,
    ...(props.clientiLinked || []),
  ];

  const filteredOrgs = allOrgs.filter(
    (org) => !orgsToExclude.includes(org.objectId)
  );

  const createCliente = useCallback(
    async (values) => {
      try {
        const token = await getTokenSilently();

        const selectedOrg = allOrgs.find(
          (org) => org.objectId === values.orgId
        );

        const variables = {
          fields: {
            org_pointer: {
              link: props.orgId,
            },
            terzista_org_pointer: {
              link: values.orgId,
            },
            cognome: selectedOrg?.nome || "",
          },
        };

        const response = await axios({
          method: "post",
          url: graphqlUrl,
          data: {
            query: CREATE_CLIENTE,
            variables,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    [getTokenSilently, allOrgs, props.orgId, graphqlUrl]
  );

  return (
    <Modal
      visible={props.visible}
      title={title}
      okText="Salva"
      cancelText="Annulla"
      maskClosable={false}
      onCancel={() => {
        setLoading(false);
        props.onCancel();
      }}
      onOk={() => {
        setLoading(true);
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            createCliente(values)
              .then(() => {
                setLoading(false);
                props.onCreate();
              })
              .catch((error) => {
                console.error(error);
                setLoading(false);
              });
          })
          .catch((info) => {
            console.error("Validate Failed:", info);
            setLoading(false);
          });
      }}
    >
      {!loading && (
        <Form
          {...layout}
          form={form}
          initialValues={{}}
        >
          <Form.Item
            label="Cliente"
            name="orgId"
            rules={[{ required: true, message: "Seleziona un cliente" }]}
          >
            <SelectOrg orgs={filteredOrgs} />
          </Form.Item>
        </Form>
      )}
      {loading && <Spin size="large" />}
    </Modal>
  );
};

export default AggiungiClienteModal;
